<template>
  <div>
    <div v-if="hasNoStationData" class="pa-4 text-xs-center">
      <v-icon>warning</v-icon>
      <br />
      No matching stations found
    </div>
    <v-list v-else dense class="pa-0 mx-0">
      <div v-if="filterToggle == filterToggles.selected && selectionCount == 0" class="pa-4 text-xs-center">
        <v-icon color="warning">warning</v-icon><br />
        No stations selected
      </div>
      <VirtualList v-show="!(filterToggle == filterToggles.selected && selectionCount == 0)" ref="virtualScroll" :size="40" :remain="6">
        <template v-for="(item, index) in timeSeriesStations">
          <template>
            <v-list-tile :key="`item-${index}`" @click="toggleStation(item.Id)">
              <v-list-tile-avatar style="min-width: 0px;"></v-list-tile-avatar>
              <v-list-tile-action style="min-width: 0px;">
                <v-checkbox @click.prevent :disabled="disabled" primary color="primary" :input-value="getStationValue(item)" hide-details />
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title class="font-weight-thin">{{ item.Identifier }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          
        </template>
      </VirtualList>
    </v-list>
  </div>
</template>

<script>
  import virtualList from 'vue-virtual-scroll-list'

  import {
    debounce,
  } from '@/helpers/performance'


  const defaultDebounceDelay = 500

  export default {
    components: {
      VirtualList: virtualList,
    },
    props: {
      filterToggle: Number,
      filterToggles: Object,
      selectionCount: Number,
      timeSeriesStations: Array,
      search: String,
      selection: Object,
      disabled: Boolean, 
    },
    data() {
      return {
        loading: {
          items: false,
        },
        searching: false,
        selected: {},
        menuProps: {
          closeOnContentClick: false,
        },
        menu: {
          show: false,
        },
        stationCategories: {},
      }
    },
    computed: {         
      hasNoStationData() {
        return !this.timeSeriesStations || this.timeSeriesStations.length == 0
      },
      isSearching() {
        return this.search && !this.loading.items
      },
      queryResults() {
        return debounce(function(value) {
          this.filteredItems = this.updateItems(value)
          this.searching = false
          this.menu.show = true
        }, defaultDebounceDelay)
      },
    },
    watch: {
      loading: {
        deep: true,
        handler(value) {
          this.$emit('loading', Object.values(value).every(v => v))
        },
      },
      searching(value) {
        this.$emit('isSearching', value)
      },
      search(value) {
        this.searching = true
        this.queryResults(value)
      },
      selected: {
        deep: true,
        handler: function(value) {
          this.$emit('selected', value)
        },
      },
      disabledStations() {
        this.$nextTick(() => {
          this.updateItems(this.search)
        })
      },
    },
    methods: {      
      untoggleAll() {
        //if (this.selectionCount == 0) return
        this.selected = {}
      },
      toggleStation(id) {
        if (this.disabled) return

        let item = this.timeSeriesStations.find(station => station.Id == id)
        if (this.selected[item.Id]) {
          this.$delete(this.selected, item.Id)
        } else {
          this.$set(this.selected, item.Id, true)
        }
      },      
      forceRender() {
        //this.$refs.virtualScroll.forceRender()
      },
      getStationValue(item) {
        return !!this.selected[item.Id]
      },
    },
  }
</script>